import { connect } from 'react-redux';
import { fetchAllProductDepositTemplates } from '@alphapoint/apex-web/lib/redux/actions/depositActions';
import { showSnack } from '@alphapoint/apex-web/lib/redux/actions/snackbarActions';
import config from '@alphapoint/apex-web/lib/config';
// eslint-disable-next-line import/no-unresolved
import { getDepositInfoWithOptions } from '@app/redux/actions/depositActions';
import ReceiveAddressComponent from './ReceiveAddressComponent';

const mapStateToProps = (state) => ({
  deposit: state.deposit,
  WalletsDisabledMessage: config.global.WalletsDisabledMessage,
});

const mapDispatchToProps = (dispatch) => ({
  selectDepositProduct: (productId) => dispatch(fetchAllProductDepositTemplates(productId)),
  fetchAccountProviderDepositInfo: (productId, accountProviderId) =>
    dispatch(getDepositInfoWithOptions(productId, { accountProviderId, generateNewKey: false })),
  generateNewDepositAddress: (productId, accountProviderId) =>
    dispatch(getDepositInfoWithOptions(productId, { accountProviderId, generateNewKey: true })),
  showSnack: (text) => dispatch(showSnack(text)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReceiveAddressComponent);
